import React from 'react';
import ReactDOM from 'react-dom/client';
import yupLocale from 'utils/yupLocale';
import 'utils/yupNumber';
import 'utils/yupString';
import * as Yup from 'yup';
import App from './App';

Yup.setLocale(yupLocale);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
